import axios from "axios";
import {
  SET_NOTIFY,
  CLOSE_NOTIFY,
  SET_WARNING,
  CLOSE_WARNING,
  SET_LOAD,
  CLOSE_LOAD
} from "../actions/type";
import { rollbar } from "../loggers";
import mediaServerAddress from "../config/mediaServerAddress";
import { batch } from "react-redux";
import * as rax from "retry-axios";

const maxRetry = 10;

const errorHandlingInterceptor = (dispatch) => {
  const instance = [axios, mediaServerAddress];
  let retryLoading = false;
  instance.forEach((x) => {
    let interceptorId = rax.attach(x);
    x.defaults.raxConfig = {
      instance: x,
      retry: maxRetry,
      noResponseRetries: maxRetry,
      retryDelay: 2000,
      statusCodesToRetry: [
        [100, 199],
        [429, 429],
        [501, 599]
      ],
      backoffType: "static",
      onRetryAttempt: (err) => {
        const cfg = rax.getConfig(err);
        retryLoading = true;

        // 🔍 SEONGGGG - Network retry attempt
        console.warn("🔍 SEONGGGG - Network RETRY attempt", {
          timestamp: new Date().toISOString(),
          retryAttempt: cfg.currentRetryAttempt,
          maxRetries: maxRetry,
          url: err.config?.url,
          method: err.config?.method,
          errorMessage: err.message,
          errorCode: err.code,
          hasResponse: !!err.response,
          responseStatus: err.response?.status,
          requestDataPreview: err.config?.data ? JSON.stringify(err.config.data).substring(0, 300) : "none"
        });

        dispatch({
          type: SET_LOAD,
          payload: `Unstable Internet:\nReconnecting ... (${cfg.currentRetryAttempt})`
        });
      }
    };
    x.interceptors.response.use(
      (res) => {
        if (retryLoading) {
          retryLoading = false;
          dispatch({ type: CLOSE_LOAD, payload: {} });
        }
        return res;
      },
      (err) => {
        // 🔍 SEONGGGG - Axios interceptor error handler
        console.error("🔍 SEONGGGG - Axios ERROR interceptor", {
          timestamp: new Date().toISOString(),
          url: err.config?.url,
          method: err.config?.method,
          errorMessage: err.message,
          errorCode: err.code,
          errorName: err.name,
          hasResponse: !!err.response,
          hasRequest: !!err.request,
          responseStatus: err.response?.status,
          responseStatusText: err.response?.statusText,
          responseData: err.response?.data,
          requestDataType: err.config?.data ? typeof err.config.data : "undefined",
          requestDataPreview: err.config?.data ?
            (typeof err.config.data === "string" ?
              err.config.data.substring(0, 500) :
              JSON.stringify(err.config.data).substring(0, 500)
            ) : "none",
          isNetworkError: !err.response && err.request,
          networkDetails: !err.response && err.request ? {
            readyState: err.request.readyState,
            status: err.request.status,
            statusText: err.request.statusText,
            responseURL: err.request.responseURL
          } : null
        });

        let errMessage = null;
        let dispatchType = SET_WARNING;
        let doLog = true;
        let forceRelogin = false;

        if (err.response) {
          errMessage = err.response.data?.error || err.message;

          if (err.response.status === 401) {
            // no 403, because S3 of TA server can not find the file will also send back 403
            errMessage =
              "When you logged into different browser or device, please login again.";
            // Force re-login to refresh JWT token
            dispatchType = SET_NOTIFY;
            doLog = false;
            forceRelogin = true;
          }
        } else if (err.request) {
          errMessage = `Unstable Internet:\nPlease check your internet connection and try again.`;

          // 🔍 SEONGGGG - Network error details
          console.error("🔍 SEONGGGG - NETWORK ERROR (no response)", {
            timestamp: new Date().toISOString(),
            url: err.config?.url,
            message: "Request was made but no response received",
            possibleCauses: [
              "DNS resolution failed (ERR_NAME_RESOLVED)",
              "Network timeout",
              "Server not responding",
              "CORS issue",
              "Connection interrupted"
            ]
          });
        } else {
          errMessage = "[Special Case] " + err.message;

          // 🔍 SEONGGGG - Special case error
          console.error("🔍 SEONGGGG - SPECIAL CASE ERROR", {
            timestamp: new Date().toISOString(),
            message: err.message,
            stack: err.stack
          });
        }

        dispatch({
          type: dispatchType,
          payload: {
            alert: errMessage,
            confirm: () => {
              batch(() => {
                dispatch({ type: CLOSE_LOAD, payload: {} });

                if (dispatchType === SET_WARNING) {
                  dispatch({ type: CLOSE_WARNING, payload: {} });
                } else if (dispatchType === SET_NOTIFY) {
                  dispatch({ type: CLOSE_NOTIFY, payload: {} });
                }
              });
            },
            forceRelogin
          }
        });
        if (doLog) rollbar.error(err);
        return Promise.reject(err);
      }
    );
  });
};

export default errorHandlingInterceptor;
